module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Eject-7dc31a34623eb6885938751ae735998605ee82f7d0bf3b6d4adb63d660cd1f65.svg";